<template>
	<footer>
		<div class="footer-top">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 col-md-6">
						<h2>Contact</h2>
						<p>
							Vous souhaitez un devis&nbsp;? Vous avez des questions&nbsp;?
							<br />Prenez rendez-vous avec moi&nbsp;!
						</p>
					</div>
					<div class="col-xs-12 col-md-6 col-contact">
						<router-link to="/contact" class="btn btn-primary white">Prendre contact</router-link>
						<router-link to="/realisation" class="lien-palette">
							<span class="hidden">Mes créations</span>
							<img src="/image/palette.png" class="img-fluid" alt="pictogramme de création" />
						</router-link>
					</div>
				</div>
			</div>
		</div>
		<div class="footer-bottom">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 col-md-3 col-lg-4">
						<nav>
							<ul>
								<li>
									<router-link to="/">Présentation</router-link>
								</li>
								<li>
									<router-link to="/realisation">Réalisations</router-link>
								</li>
								<li>
									<router-link to="/contact">Contact</router-link>
								</li>
								<li>
									<router-link to="/mentions-legales">Mentions légales</router-link>
								</li>
							</ul>
						</nav>
					</div>
					<div class="col-xs-12 col-md-4">
						<router-link to="/">
							<span class="hidden">Marion Création - Accueil</span>
							<img src="/image/logo-orange.png" class="img-fluid" alt="Marion Création" />
						</router-link>
					</div>
					<div class="col-xs-12 col-md-5 col-lg-4">
						<ul class="footer-liste-picto">
							<li>
								<a
									href="https://www.facebook.com/Marion-Cr%C3%A9ation-263307740827706/"
									class="footer-facebook"
									target="_blank"
								>Marion Création</a>
							</li>
							<li>
								<router-link
									to="/contact"
									class="footer-mail email"
									data-user="choveaumarion"
									data-website="gmail.com"
								>
									<span class="hidden">L'adresse email de Marion Création</span>
								</router-link>
							</li>
							<li>
								<router-link to="/contact" class="footer-tel">02 51 87 66 06</router-link>
							</li>
							<li>
								<router-link to="/contact" class="footer-adresse">ZA de Cloupinot, 85570 Petosse</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: "Footer",
	props: {}
};
</script>
